<template>
  <div>
    <section class="con6">
      <div class="container inner">
        <ul class="main-list">
          <li>
            <div class="main-title">
              <p>위클리 클래스</p>
              <div class="line"></div>
            </div>
            <ul class="sub-list">
              <li>
                <img src="@/assets/img/centerone/con6/img1.png" alt="img" />
                <p>마인드풀 글쓰기와 스케치</p>
                <p>
                  명상으로 내면을 탐색하며 진정한 나의 모습을 찾아가는<br />글쓰기와
                  표현예술 워크숍
                </p>
              </li>
              <li>
                <img src="@/assets/img/centerone/con6/img2.png" alt="img" />
                <p>원데이 리트릿 _ 숲명상 프로그램</p>
                <p>
                  자연속에 있으면 마음이 평온해집니다.<br />숲명상 전문가의
                  리딩으로 리프레시 경험합니다.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <div class="main-title">
              <p>스페셜 프로그램</p>
              <div class="line"></div>
            </div>
            <ul class="sub-list">
              <li>
                <img src="@/assets/img/centerone/con6/img3.png" alt="img" />
                <p>원데이 명상 수업 _ 해방촌의 아침</p>
                <p>
                  초보자들도 쉽게 배울 수 있는 따뜻한 명상 수업.<br />에니어그램,
                  MSS 설문으로 심리기반 입체적 운영.
                </p>
              </li>
              <li>
                <img src="@/assets/img/centerone/con6/img4.png" alt="img" />
                <p>센터원 멤버십</p>
                <p>
                  변화를 만드는 현업 리더 도반들을 만납니다.<br />1:1 명상코칭,
                  데일리 프로그램, 차 명상 etc
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.br-pc {
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
}

// con6
.con6 {
  padding: 70px 0;
  background-color: #f7f2ec;

  @media screen and (min-width: 1200px) {
    padding: 150px 0;
  }

  .inner {
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    .main-list {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 70px;

      @media screen and (min-width: 1200px) {
        gap: 120px;
      }

      .main-title {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 30px;

        @media screen and (min-width: 1200px) {
          gap: 26px;
          margin-bottom: 54px;
        }

        p {
          font-size: 30px;
          font-weight: 700;
          flex: none;

          @media screen and (min-width: 1200px) {
            font-size: 46px;
          }
        }

        .line {
          width: 100%;
          height: 1px;
          background-color: #9f9f9f;
        }
      }

      .sub-list {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 30px;

        @media screen and (min-width: 1200px) {
          grid-template-columns: repeat(2, 1fr);
          gap: 100px;
        }

        li {
          img {
            margin-bottom: 20px;

            @media screen and (min-width: 1200px) {
              margin-bottom: 40px;
            }
          }

          p {
            &:nth-of-type(1) {
              font-size: 20px;
              font-weight: 700;
              margin-bottom: 10px;

              @media screen and (min-width: 1200px) {
                font-size: 30px;
                margin-bottom: 20px;
              }
            }

            &:nth-of-type(2) {
              color: #3e3e3e;
              line-height: 22px;

              @media screen and (min-width: 1200px) {
                font-size: 20px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
